// src/pages/FAQ.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ = () => {
  const { t, language } = useLanguage();

  const driverFAQs = [
    { question: 'driver_faq_1_question', answer: 'driver_faq_1_answer' },
    { question: 'driver_faq_2_question', answer: 'driver_faq_2_answer' },
    { question: 'driver_faq_3_question', answer: 'driver_faq_3_answer' },
    { question: 'driver_faq_4_question', answer: 'driver_faq_4_answer' },
    { question: 'driver_faq_5_question', answer: 'driver_faq_5_answer' },
    { question: 'driver_faq_6_question', answer: 'driver_faq_6_answer' },
    { question: 'driver_faq_7_question', answer: 'driver_faq_7_answer' },
    { question: 'driver_faq_8_question', answer: 'driver_faq_8_answer' },
  ];

  const restaurantFAQs = [
    { question: 'restaurant_faq_1_question', answer: 'restaurant_faq_1_answer' },
    { question: 'restaurant_faq_2_question', answer: 'restaurant_faq_2_answer' },
    { question: 'restaurant_faq_3_question', answer: 'restaurant_faq_3_answer' },
    { question: 'restaurant_faq_4_question', answer: 'restaurant_faq_4_answer' },
  ];

  const generalFAQs = [
    { question: 'general_faq_1_question', answer: 'general_faq_1_answer' },
    { question: 'general_faq_2_question', answer: 'general_faq_2_answer' },
    { question: 'general_faq_3_question', answer: 'general_faq_3_answer' },
    { question: 'general_faq_4_question', answer: 'general_faq_4_answer' },
  ];

  const renderFAQSection = (faqs, sectionTitle) => (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom sx={{ 
        fontWeight: 'bold',
        textAlign: language === 'ar' ? 'right' : 'left',
        mb: 3
      }}>
        {t(sectionTitle)}
      </Typography>
      {faqs.map((faq, index) => (
        <Accordion key={index} sx={{ 
          mb: 2,
          direction: language === 'ar' ? 'rtl' : 'ltr',
          '& .MuiAccordionSummary-content': {
            textAlign: language === 'ar' ? 'right' : 'left',
          }
        }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <Typography>{t(faq.question)}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ 
              textAlign: language === 'ar' ? 'right' : 'left',
              lineHeight: 1.6
            }}>
              {t(faq.answer)}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ 
        fontWeight: 'bold',
        textAlign: 'center',
        mb: 2
      }}>
        {t('faq')}
      </Typography>
      
      <Typography variant="body1" sx={{ 
        textAlign: 'center',
        mb: 6,
        color: 'text.secondary'
      }}>
        {t('faq_description')}
      </Typography>

      {renderFAQSection(driverFAQs, 'driver_faq_section')}
      {renderFAQSection(restaurantFAQs, 'restaurant_faq_section')}
      {renderFAQSection(generalFAQs, 'general_faq_section')}

      <Box sx={{ 
        textAlign: 'center',
        mt: 6,
        p: 3,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 1
      }}>
        <Typography variant="h6" gutterBottom>
          {t('faq_not_found')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('contact_support')}
        </Typography>
      </Box>
    </Container>
  );
};

export default FAQ;